import styled from "styled-components";

export const LoginDiv = styled.div`
  display: grid;
  height: 100vh;

  grid-template-columns: 1.5fr 1fr;
  @media (max-width: 1200px) {
    grid-template-columns: 1fr;
  }
`;

export const ImageLogin = styled.img`
  height: 100vh;
  object-fit: cover;
  width: 100%;
  @media (max-width: 1200px) {
    display: none;
  }
`;
